// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_GAN5v","foot_link":"index_foot_link_-RCdc","list":"index_list_2Hjgt","link":"index_link_-EOLU","copyright":"index_copyright_DXdUY"};